import clsx from 'clsx';
import { useRef } from 'react';
import { useHoverDirty } from 'react-use';
import { Content, useContent } from 'src/contexts/ContentContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { Tooltip } from 'src/core/ui';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { IconsFill, InfoOutlineIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { getInHandDisplayData } from 'src/utils/saleUtils';
import { Feature } from 'src/WebApiController';

import { inhandDateContainer } from './InHandDateDisplay.css';

export function InHandDateDisplay({
  date,
  needsToFulfill,
  handleFulfillmentState,
  inHandDateOverriddenByMsbd,
  showAbsoluteDate = false,
  className,
}: {
  date?: Date | null;
  needsToFulfill?: boolean;
  handleFulfillmentState?: boolean;
  inHandDateOverriddenByMsbd?: boolean | null;
  showAbsoluteDate?: boolean;
  className?: string;
}) {
  const elementRef = useRef<HTMLInputElement>(null);
  const isHovering = useHoverDirty(elementRef);
  const inhand = useContent(ContentId.InHand);
  const ihdTimezoneFix = useUserHasFeature(Feature.IhdTimezoneFix);

  const { isDarkMode } = useSiteTheme();

  const dateLocal = ihdTimezoneFix
    ? date
    : date &&
      new Date(
        Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds()
        )
      );

  const { displayText, displayTooltip, alertIcon } = getInHandDisplayData(
    inhand,
    dateLocal,
    new Date(),
    needsToFulfill,
    showAbsoluteDate
  );

  if (!needsToFulfill && handleFulfillmentState) {
    return null;
  }

  return (
    <div
      title={displayTooltip ?? undefined}
      className={clsx(inhandDateContainer, className)}
    >
      {handleFulfillmentState && alertIcon}
      {inHandDateOverriddenByMsbd && (
        <Tooltip
          open={isHovering}
          delayDuration={100}
          contentVariant={isDarkMode ? 'light' : 'dark'}
          triggerContent={
            <div ref={elementRef} style={{ display: 'flex' }}>
              <InfoOutlineIcon
                size={vars.iconSize.s}
                fill={IconsFill.textWarning}
              />
            </div>
          }
        >
          <Content id={ContentId.InHandDateOverriddenByMsbd} />
        </Tooltip>
      )}
      <span>{displayText}</span>
    </div>
  );
}
